import script from "./Research.vue?vue&type=script&setup=true&lang=js"
export * from "./Research.vue?vue&type=script&setup=true&lang=js"

import "./Research.vue?vue&type=style&index=0&id=9328091a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9328091a"]])

export default __exports__